import { useCallback, useState } from 'react';
import { BubbleButton } from 'structure/home/components/DappWorld/BubbleButton';
import { BubbleContent } from 'structure/home/components/DappWorld/BubbleContent';
import { BubbleMarker } from 'structure/home/components/DappWorld/BubbleMarker';
import { useIntervalV2 } from '@dapp/multi-lib/ui/shared-hooks/useInterval';
import { Header2 } from 'structure/home/components/Typography';

interface BubbleContent {
  title: string;
  description: string;
  buttonLabel: string;
}

const poweringEconomyBubbleContent: BubbleContent[] = [
  {
    title: 'DeFi-as-a-Service',
    description:
      'AI-agent startups can leverage SFI’s DeFi-as-a-Service to access staking, farming, and bonding, enabling seamless liquidity and growth with AI-guided strategies tailored for success.',
    buttonLabel: 'DeFi-as-a-Service',
  },
  {
    title: 'Data-Driven Insights',
    description:
      'Optimize DeFi moves with AI-analyzed onchain data, delivering actionable insights for startups and investors to make smarter, faster decisions in the agentic economy.',
    buttonLabel: 'Data-Driven Insights',
  },
  {
    title: 'Autonomous Trading',
    description:
      'SFI’s autonomous AI agents trade while you sleep. These smart, non-custodial strategies that maximize profits and adapt to market shifts effortlessly.',
    buttonLabel: 'Autonomous Trading',
  },
];

interface DappWorldProps {
  anchorId: string;
}

export function DappWorld({ anchorId }: DappWorldProps) {
  const [state, setState] = useState<number>(0);

  const updateState = useCallback(() => {
    setState((prev) => {
      return prev === poweringEconomyBubbleContent.length - 1 ? 0 : prev + 1;
    });
  }, []);

  const { restart } = useIntervalV2({ callback: updateState, timeout: 5000 });

  const handleChangeIndex = (idx: number) => {
    setState(idx);
    restart();
  };

  const isActive = (idx: number) => {
    return idx === state;
  };

  return (
    <div
      id={anchorId}
      className='relative flex h-full flex-col justify-around gap-8 nglg:gap-20 ng2xl:gap-12'
    >
      <div className='flex flex-col gap-8'>
        <div className='flex flex-col gap-4 nglg:gap-10'>
          <Header2 as='h2' className='text-center'>
            Monetising the Agentic Economy
          </Header2>
          {/*<Body2*/}
          {/*  as='p'*/}
          {/*  className='text-center text-sm nglg:text-base ng2xl:text-xl'*/}
          {/*>*/}
          {/*  Tokenization stands to redefine how value is created and exchanged*/}
          {/*  in the AI economy, allowing the unlocking of new asset classes.*/}
          {/*  Singularity Finance monetises the AI value chain through tokenizing*/}
          {/*  the AI assets and allowing the network participants to earn a part*/}
          {/*  of the yield generated.*/}
          {/*</Body2>*/}
        </div>
        <div
          className={`flex h-[267px] max-h-max shrink-0 flex-col justify-between gap-4 rounded-3xl border border-softYellow bg-[#1E1E1E] p-6 [background:linear-gradient(69.35deg,_#144E41_0.07%,_#111111_100.07%)] sm:h-[225px] md:h-[204px] lg:h-auto nglg:gap-10 nglg:rounded-3xl nglg:p-10`}
        >
          {poweringEconomyBubbleContent[state] && (
            <BubbleContent
              title={poweringEconomyBubbleContent[state].title}
              description={poweringEconomyBubbleContent[state].description}
            />
          )}
          <div className='lgmd:gap-auto flex flex-row justify-center gap-10'>
            {poweringEconomyBubbleContent.map((item, idx) => (
              <BubbleMarker
                key={idx}
                active={isActive(idx)}
                onClick={() => handleChangeIndex(idx)}
              />
            ))}
          </div>
        </div>
      </div>
      <div className='flex flex-row flex-wrap items-center justify-center gap-5 ng2xl:flex-row ng2xl:justify-center'>
        {poweringEconomyBubbleContent.map((content, idx) => (
          <BubbleButton
            key={idx}
            active={isActive(idx)}
            onClick={() => handleChangeIndex(idx)}
          >
            {content.buttonLabel}
          </BubbleButton>
        ))}
      </div>
    </div>
  );
}
